import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-accept-conditions',
  templateUrl: './accept-conditions.component.html',
  styleUrls: ['./accept-conditions.component.scss']
})
export class AcceptConditionsComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() controlName: string;
  @Input() inputLink: string;
  @Input() inputText: string;
  @Input() disable: boolean = null;
  @Output() changeAccepted = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  changedCheckBox(event) {
    this.changeAccepted.emit(event.checked);
  }
}
